import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const ChatFormInput = ({
                           children,
                           type,
                           label,
                           onChange,
                           value,
                           disabled,
                           toggleFocusOn,
                           required,
                           hidden,
                           onSubmit
                       }) => {

    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current.focus();
    }, [toggleFocusOn]);

    return (
        <form id="response" onSubmit={onSubmit} onClick={() => inputRef.current.focus()}>
			<textarea
                name="message"
                className="response"
                type={type}
                placeholder={label}
                onChange={onChange}
                value={value}
                required={required}
                disabled={disabled}
                ref={inputRef}
                hidden={hidden}
            />
            {children}
        </form>
    );
};

ChatFormInput.propTypes = {
    type: PropTypes.string,
    onSubmit: PropTypes.func,
    label: PropTypes.string,
    src: PropTypes.string,
    onChange: PropTypes.func,
    email: PropTypes.string,
    valueToActive: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    value: PropTypes.string,
    fade: PropTypes.string,
    fadeOut: PropTypes.string,
    disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    ref: PropTypes.string,
    toggleFocusOn: PropTypes.bool,
    required: PropTypes.bool,
    hidden: PropTypes.bool,
    children: PropTypes.node
};

export default ChatFormInput;